// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".request_data_name[data-v-2a09e261]{font-size:12px!important;color:#222!important;font-weight:700;padding:10px 20px}.reques_data_value[data-v-2a09e261]{font-size:12px!important;color:#444!important;font-weight:300}.input_text_type_basic.file_type>div[data-v-2a09e261]:nth-of-type(odd){float:none}", ""]);
// Exports
module.exports = exports;
